module.exports = __webpack_public_path__ + "media/assets/img/slider/03-f098ec19aeefb6d18944bfe5cfcf8d2a.jpg";